import { useEffect, useCallback, useRef } from 'react';
import { OverlayScrollbars } from 'overlayscrollbars';
import { classes } from './useOverlayScrollabr.st.css.js';
/**
 * @param params Parameters for customization.
 * @returns A tuple with two values:
 * The first value is the container ref that should be attached to container that should be scrolled.
 * The second value is a scrollbars styles class name that should be attached to the container as well.
 */
export const useOverlayScrollbar = (params = {
    options: { scrollbars: { autoHide: 'leave', autoHideDelay: 0 } },
}) => {
    const { options } = params;
    const scrollableContainerRef = useRef(null);
    const instanceRef = useRef(null);
    const initialize = useCallback((target) => {
        // if already initialized do nothing
        if (OverlayScrollbars.valid(instanceRef.current)) {
            return;
        }
        /**
         * If the environment is test or window is undefined,
         * do not initialize the OverlayScrollbars.
         */
        if (process.env.NODE_ENV === 'test' || typeof window === 'undefined') {
            return;
        }
        instanceRef.current = OverlayScrollbars(target, options || {});
    }, [options]);
    useEffect(() => {
        if (scrollableContainerRef.current) {
            initialize(scrollableContainerRef.current);
        }
    }, [initialize]);
    return [scrollableContainerRef, classes.root];
};
//# sourceMappingURL=useOverlayScrollbar.js.map